import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { AddAttachmentResponseContentDto } from '@/api/generated';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  emailId: string;
  file: File;
  inline?: boolean;
};

type Return = {
  addAttachment: (req: Req) => Promise<AddAttachmentResponseContentDto>;
  isAddingAttachment: boolean;
  isErrorAddingAttachment: boolean;
};

export const useAddAttachment = (): Return => {
  const { emailUpdateApi } = useEmailApiClient();
  const { userId } = useUserContext();

  const { isError, isPending, mutateAsync } = useMutation<
    AddAttachmentResponseContentDto,
    AxiosError,
    Req
  >({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const { data } = await emailUpdateApi.addAttachment(
        userId,
        req.emailId,
        req.file,
        req.inline,
      );
      return data;
    },
  });

  return {
    addAttachment: mutateAsync,
    isAddingAttachment: isPending,
    isErrorAddingAttachment: isError,
  };
};
